import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Container, Row, Col, Image } from 'react-bootstrap';
import { sendPasswordResetEmail, auth } from '../../firebase/firebase'; // Import necessary functions
import { Fade } from 'react-awesome-reveal';
import logo from '../../assets/app-logo.png';
import './ForgotPassword.css'; // Import the CSS

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Password reset email sent. Check your inbox (and spam folder).');
            // Optionally redirect after a delay or keep the user on the page
            // setTimeout(() => navigate('/login'), 5000);
        } catch (err) {
            setError(err.message || 'Failed to send password reset email. Please try again.');
            console.error("Password Reset Error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-page-container">
            <Container className='form-container'>
                <Row className="justify-content-center h-100">
                    <Col xs={12} sm={10} md={8} lg={6}>
                        <Image src={logo} onClick={() => navigate('/')} alt="Right Spade Logo" className='mb-3 ms-4 ms-md-0 logo-img cursor-pointer' />
                        <Fade direction="up" triggerOnce cascade damping={0.1}>
                            <div className="forgot-password-form-wrapper">
                                <h2 className="text-center mb-4">Reset Password</h2>
                                {error && <Alert variant="danger">{error}</Alert>}
                                {message && <Alert variant="success">{message}</Alert>}
                                <Form onSubmit={handleSubmit} className='form-wrap'>
                                    <div className="form-fld-wrp">
                                        <Form.Group className="mb-3" controlId="formForgotPasswordEmail">
                                            <Form.Label>E-mail Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter your registered email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="form-footer">
                                        <Button variant="primary" type="submit" className="reset-button" disabled={loading}>
                                            {loading ? 'Sending...' : 'Send Reset Email'}
                                        </Button>

                                        <p className="login-link-text mt-3">
                                            <Link to="/login">Back to Login</Link>
                                        </p>
                                    </div>
                                </Form>
                            </div>
                        </Fade>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ForgotPassword; 